// This is the landing page of the website
import '../style/main.css';
import Landing from '../components/Landing.js';
import Meta from '../components/Meta.js';

function Home() {
	return (
		<>
			<Meta title='Borealis Blades Historical Fencing' />
			<Landing />
		</>
	);
};

export default Home;
